import { Component } from '@angular/core';

@Component({
  selector: 'app-stripe-payment',
  templateUrl: './stripe-payment.component.html',
  styleUrl: './stripe-payment.component.scss'
})
export class StripePaymentComponent {
  student: any = { firstName: '', lastName: '', email: '', mobileNo: '', companyName: '' };
    bookingReference = '';



    
}
